import { cn } from '@kidshome/ui';

/**
 * A calm loading spinner (respects reduced-motion). `currentColor`, so it tints with the surrounding text.
 * Not a `LineIcon` (it animates + uses two strokes), but it lives with the chrome icons as the loading mark.
 */
export function Spinner({
  size = 20,
  className,
}: {
  size?: number;
  className?: string;
}): React.ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={cn('animate-spin motion-reduce:animate-none', className)}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.5" strokeOpacity="0.25" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
